import React, { useState } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { GET_UNPAID_INVOICES, MAKE_PAYMENT } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';
import { useTranslation } from 'react-i18next';
import NewPayment from './NewPayment';
import Helper from '../../../helper/Helper';
import Alert from '../../../feature/Alert';
import { useNavigate } from 'react-router-dom';
import SelectCustomer from '../layout/SelectCustomer';


export default function Payment() {

  const [customerId, setCustomerId] = useState('');
  const { t } = useTranslation();
  const [invoices, setUnpaidInvoices] = useState([]);
  const [payment, setPayment] = useState({});
  const headers = ['date', 'number', 'amount', 'due_amount', 'payment_value'];
  const [total, setTotal] = useState({ receivedAmount: 0, usedAmount: 0, excessAmount: 0 });
  const [other, setOther] = useState({ notes: '' });
  const thStyle = { lineHeight: "2", verticalAlign: "center" };
  const navigate = useNavigate();

  const getUnpaidInvoices = async (customer_id) => {
    const res = await httpClient.post(GET_UNPAID_INVOICES, { customer_id: customer_id });
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        let data = result.data;
        let option = [];
        data.forEach(element => {
          option.push({
            invoice_date: element.invoice_date,
            invoice_id: element.invoice_id,
            prefix: element.prefix,
            invoice_number: element.invoice_number,
            pending_amount: element.pending_amount,
            net_amount: element.net_amount,
            payment_value: 0,
          });
        })
        setUnpaidInvoices(option);
      }
    }
  }

  const addPayment = (paymentDetails) => {
    let amount = parseFloat(paymentDetails.amount);
    const updatedInvoices = invoices.map(invoice => {
      if (amount > 0) {
        if (parseFloat(invoice.pending_amount) <= amount) {
          amount = amount - parseFloat(invoice.pending_amount);
          return { ...invoice, payment_value: Helper.formatNumber(invoice.pending_amount) };
        } else if (parseFloat(invoice.pending_amount) > amount) {
          const temp_amount = amount;
          amount = 0;
          return { ...invoice, payment_value: Helper.formatNumber(temp_amount) };
        }
      }
      return { ...invoice, payment_value: 0 };
    });
    setTotal(prevTotal => ({
      ...prevTotal,
      receivedAmount: Helper.formatNumber(paymentDetails.amount),
      excessAmount: Helper.formatNumber(amount),
      usedAmount: Helper.formatNumber(parseFloat(paymentDetails.amount) - parseFloat(amount))
    }));
    setUnpaidInvoices(updatedInvoices);
    setPayment(paymentDetails);
  }

  const handleAmount = (index, event) => {
    const amount = parseFloat(event.target.value);
    const updatedInvoices = invoices.map((invoice, i) => {
      if (i === index) {
        if (amount <= parseFloat(invoice.pending_amount)) {
          return { ...invoice, payment_value: amount };
        }
      }
      return invoice;
    });
    setUnpaidInvoices(updatedInvoices);
  };

  const handleBlur = (index, event) => {
    const amount = parseFloat(event.target.value);
    let remainingPayment = parseFloat(payment.amount);
    const updatedInvoices = invoices.map((invoice, i) => {
      if (i === index) {
        if (amount <= parseFloat(invoice.pending_amount)) {
          remainingPayment -= amount;
          return { ...invoice, payment_value: Helper.formatNumber(amount) };
        } else {
          remainingPayment -= parseFloat(invoice.pending_amount);
          return { ...invoice, payment_value: Helper.formatNumber(invoice.pending_amount) };
        }
      }
      return invoice;
    });

    setUnpaidInvoices(updatedInvoices);
    const updatedInvoices2 = invoices.map((invoice, i) => {
      if (i !== index) {
        if (parseFloat(invoice.pending_amount) <= remainingPayment) {
          remainingPayment -= parseFloat(invoice.pending_amount);
          return { ...invoice, payment_value: Helper.formatNumber(invoice.pending_amount) };
        } else if (parseFloat(invoice.pending_amount) > remainingPayment) {
          const tempAmount = remainingPayment;
          remainingPayment = 0;
          return { ...invoice, payment_value: Helper.formatNumber(tempAmount) };
        }
      }
      return invoice;
    });
    setUnpaidInvoices(updatedInvoices2);
    setTotal(prevTotal => ({
      ...prevTotal,
      excessAmount: Helper.formatNumber(remainingPayment),
      usedAmount: Helper.formatNumber(parseFloat(payment.amount) - parseFloat(remainingPayment))
    }));
  };

  const handleInputChange = (fieldName, event) => {
    const value = event.target.value;
    const formData = { ...other };
    formData[fieldName] = value;
    setOther(formData);
  };

  const savePayment = async () => {
    if (customerId !== '') {
      if (Object.keys(payment).length !== 0) {
        if (payment.mode !== '') {
          if (parseFloat(payment.amount) > 0) {
            const post = { customer_id: customerId, notes: other.notes, payment: payment, invoices: invoices, total: total };
            const res = await httpClient.post(MAKE_PAYMENT, post);
            if (res.requestStatus === "OK") {
              const result = res.result;
              if (result.status === 1) {
                Alert.success(result.message);
                navigate('/root/payment');
              } else {
                Alert.failure(result.message);
              }
            }
          } else {
            Alert.error("Payment amount is required!");
          }
        } else {
          Alert.error("Save Payment before process!");
        }
      } else {
        Alert.error("Save Payment before process!");
      }
    } else {
      Alert.error("Select Customer");
    }
  }

  const remitCustomer = (data) => {
    setCustomerId(data.customer_id);
    getUnpaidInvoices(data.customer_id);
  }

  return (
    <AdminLayout>
      <div className="content-wrapper">
        <ContentHeader title="customer_payment" subTitle="payment" subTitleLink="root/payment" />
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div>
                <SelectCustomer remitCustomer={remitCustomer} />
              </div>
              <NewPayment onClick={addPayment} />
              <hr />
              <div>
                <h5 className='mb-2'>{t('unpaid_documents')}</h5>
                <div>
                  <table className="text-center table table-striped table-sm table-hover">
                    <thead className='bg-primary text-white'>
                      <tr className=''>
                        {headers.map((header, index) => (
                          <th key={index}>{t(header)}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {
                        invoices.map((row, index) => (
                          <tr key={index}>
                            <td>{row.invoice_date}</td>
                            <td>{row.prefix} - {row.invoice_number}</td>
                            <td>{row.net_amount}</td>
                            <td>{row.pending_amount}</td>
                            <td>
                              <input type='number' className='form-control form-control-sm' value={row.payment_value} onChange={(e) => handleAmount(index, e)}
                                onBlur={(e) => handleBlur(index, e)} />
                              <span className='text-danger'></span>
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
                <hr />
                <div className='row mt-3'>
                  <div className='col-md-8'>
                    <label>{t('notes')}</label>
                    <textarea className='form-control' onChange={(e) => handleInputChange('notes', e)} value={other.notes} ></textarea>
                  </div>
                  <div className='col-md-4 '>
                    <table className='table table-sm table-borderless'>
                      <tbody>
                        {
                          total.receivedAmount > 0 &&
                          <tr>
                            <td style={thStyle} ><strong>{t('amount_received')}</strong></td>
                            <td style={thStyle} className='text-right'><strong>{total.receivedAmount}</strong></td>
                          </tr>
                        }
                        {
                          total.usedAmount > 0 &&
                          <tr>
                            <td style={thStyle} ><strong>{t('amount_used_for_payments')}</strong></td>
                            <td style={thStyle} className='text-right'><strong>{total.usedAmount}</strong></td>
                          </tr>
                        }
                        {
                          total.excessAmount > 0 &&
                          <tr>
                            <td style={thStyle}><strong>{t('amount_in_excess')}</strong></td>
                            <td style={thStyle} className='text-right'><strong>{total.excessAmount}</strong></td>
                          </tr>
                        }

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <hr />
              <div className='text-center'>
                <button className='btn btn-primary auto_click' onClick={savePayment}>{t('save')}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  )
}
